import React from 'react';
import { Button } from '../../elements';
import { T } from '../../helpers/i18n';
export const PrintRefund = ({ ticket, onPrint, onRefund }) => {
    return (React.createElement("div", { className: "btn-detail", style: { flexDirection: 'row', justifyContent: 'space-evenly' } },
        React.createElement(Button, { primary: true, 
            /*disabled={ticket.daterefund!== null || ticket.refund_id !== null}*/
            style: { alignContent: 'end' }, onClick: () => onRefund(ticket) }, T('refund'))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/PrintRefund.tsx
// module id = 507
// module chunks = 0